import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=1d1f0aeb&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"
import style0 from "./TaskCard.vue?vue&type=style&index=0&id=1d1f0aeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1f0aeb",
  null
  
)

export default component.exports